import request from "@/plugins/axiosRequest";

const sign_up_url = "/auth";
const sign_in_url = "/auth/sign_in";
const sign_out_url = "/auth/sign_out";
const validate_token_url = "/auth/validate_token";
const update_password_url = "/auth/password";
const update_profile_url = "/auth";

export function registerByEmail(
  email,
  password,
  passwordConfirmation,
  successUrl
) {
  const data = {
    email,
    password,
    password_confirmation: passwordConfirmation,
    confirm_success_url: successUrl
  };
  return request({
    url: sign_up_url,
    method: "POST",
    data
  });
}

export function loginByEmail(email, password) {
  const data = {
    email,
    password
  };
  return request({
    url: sign_in_url,
    method: "POST",
    data
  });
}

export function logout() {
  return request({
    url: sign_out_url,
    method: "DELETE"
  });
}

export function validateToken() {
  return request({
    url: validate_token_url,
    method: "GET"
  });
}

export function updatePassword(
  current_password,
  password,
  password_confirmation
) {
  const data = {
    current_password: current_password,
    password: password,
    password_confirmation: password_confirmation
  };
  return request({
    url: update_password_url,
    method: "PUT",
    data
  });
}
export function updateProfile(data) {
  return request({
    url: update_profile_url,
    method: "PUT",
    data
  });
}

export function sendResetPassword(email, redirectUrl) {
  const data = {
    email,
    redirect_url: redirectUrl
  };
  return request({
    url: update_password_url,
    method: "POST",
    data
  });
}

export function resetPassword({ token, password, passwordConfirmation }) {
  const data = {
    reset_password_token: token,
    password: password,
    password_confirmation: passwordConfirmation
  };
  return request({
    url: update_password_url,
    method: "PUT",
    data
  });
}
